// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRouter from './AppRouter';
import { HelmetProvider } from 'react-helmet-async';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import './App.css';

// ✅ GA4 helpers
import { initAnalytics, trackPageView } from './utils/analytics';

// GA4 Measurement ID (format: G-XXXXXXX)
const MEASUREMENT_ID = process.env.REACT_APP_GA_ID || 'G-C5MHL5N3PN';

// This child lives *inside* BrowserRouter, so it can use useLocation()
function AnalyticsAndShell() {
  const location = useLocation();

  // Initialize GA4 once on mount
  useEffect(() => {
    initAnalytics(MEASUREMENT_ID);
  }, []);

  // Track every route change
  useEffect(() => {
    // page_path should include search if present
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <div className="App min-h-screen flex flex-col bg-off-white">
      <Navigation />
      <main className="flex-grow pt-20 md:pt-24">
        <AppRouter />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AnalyticsAndShell />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
